import apiBase from "../../api/axios";

// ─── Actividades ────────────────────────────────────────

/**
 * Listar actividades.
 * @param {Object} params - Query params: search, ordering
 */
export const getActividadesService = async ({
  search = "",
  ordering = "-created_at",
  alumnoId = "",
  estado = "",
  revision = "",
  desde = "",
  hasta = "",
} = {}) => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (ordering) params.append("ordering", ordering);
  if (alumnoId) params.append("alumno_id", alumnoId);
  // revision tiene prioridad sobre estado (el backend lo maneja así)
  if (revision) {
    params.append("revision", revision);
  } else if (estado) {
    params.append("estado", estado);
  }
  if (desde) params.append("desde", desde);
  if (hasta) params.append("hasta", hasta);

  const queryString = params.toString();
  const url = `v1/classroom/actividades/${queryString ? `?${queryString}` : ""}`;
  const response = await apiBase.get(url);
  // La API devuelve { count, next, previous, results }
  const data = response.data;
  return {
    actividades: data?.results ?? [],
    count: data?.count ?? 0,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
  };
};

/**
 * Obtener detalle de una actividad.
 */
export const getActividadByIdService = async (id) => {
  const response = await apiBase.get(`v1/classroom/actividades/${id}/`);
  return response.data;
};

/**
 * Crear una nueva actividad (docente/superusuario).
 */
export const createActividadService = async (payload) => {
  const response = await apiBase.post("v1/classroom/actividades/", payload);
  return response.data;
};

/**
 * Actualizar actividad (PUT).
 */
export const updateActividadService = async (id, payload) => {
  const response = await apiBase.put(`v1/classroom/actividades/${id}/`, payload);
  return response.data;
};

/**
 * Actualizar actividad parcial (PATCH).
 */
export const patchActividadService = async (id, payload) => {
  const response = await apiBase.patch(`v1/classroom/actividades/${id}/`, payload);
  return response.data;
};

/**
 * Eliminar actividad.
 */
export const deleteActividadService = async (id) => {
  const response = await apiBase.delete(`v1/classroom/actividades/${id}/`);
  return response.data;
};

/**
 * Entregar actividad (alumno).
 * @param {number} id - ID de la actividad
 * @param {FormData} formData - archivos[] y comentario_alumno
 */
export const entregarActividadService = async (id, formData) => {
  // Eliminar Content-Type del default para que axios autodetecte multipart/form-data + boundary
  const response = await apiBase.post(
    `v1/classroom/actividades/${id}/entregar/`,
    formData,
    {
      headers: { "Content-Type": null },
      transformRequest: [(data) => data],
    },
  );
  return response.data;
};

/**
 * Revisar entrega (docente).
 */
export const revisarActividadService = async (id, payload) => {
  const response = await apiBase.post(
    `v1/classroom/actividades/${id}/revisar/`,
    payload,
  );
  return response.data;
};

/**
 * Eliminar un archivo de una entrega (alumno/superuser).
 * El alumno puede borrar archivos viejos cuando el docente
 * rechaza la entrega y la actividad vuelve a PENDIENTE.
 */
export const deleteArchivoService = async (actividadId, archivoId) => {
  const response = await apiBase.delete(
    `v1/classroom/actividades/${actividadId}/archivos/${archivoId}/`,
  );
  return response.data;
};

// ─── Estudiantes (para asignación) ──────────────────────

/**
 * Obtener lista de alumnos del mentor.
 * @param {string} search - Término de búsqueda (opcional)
 */
export const getMisEstudiantesService = async (search = "") => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  const queryString = params.toString();
  const url = `v1/seguimiento/mis-alumnos/${queryString ? `?${queryString}` : ""}`;
  const response = await apiBase.get(url);
  return response.data;
};
